import script from "./form-drawer-1.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-drawer-1.vue?vue&type=script&lang=ts&setup=true"

import "./form-drawer-1.vue?vue&type=style&index=0&id=2ed497e4&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed497e4"]])

export default __exports__